import { useTheme } from 'styled-components'

import { Multiselect } from '@components/Multiselect'

import { FormLabel } from './FormLabel'

interface IItem {
  description: string
  id: number
}

interface IProps {
  items: IItem[]
  label?: string
  errorMessage?: string
  isRequired?: boolean
  onChange?: (values: number[]) => void
  defaultValues?: (number | undefined)[] | undefined
  isDisabled?: boolean
  placeHolder?: string
}

export function FormMultiselect({
  label,
  errorMessage,
  isRequired,
  ...rest
}: IProps) {
  const { colors } = useTheme()

  const invalid = !!errorMessage

  const borderColor = invalid ? colors.textError : colors.formBorder
  const borderWidth = invalid ? 2 : 1

  return (
    <div style={{ marginBottom: 16 }}>
      <FormLabel isInvalid={invalid} isRequired={isRequired}>
        {label}
      </FormLabel>
      <Multiselect
        borderColor={borderColor}
        borderWidth={borderWidth}
        {...rest}
      />

      {invalid && <span style={{ color: colors.textError, fontSize: 12 }}>{errorMessage}</span>}
    </div>
  )
}
